module.exports = __webpack_public_path__ + "site/img/team_member_sign_Yvonne.1e0d3ad0.png";